import React from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { useTranslation } from "@/context/LanguageContext";

export default function Navbar({ onCtaClick }) {
  const [open, setOpen] = React.useState(false);
  const { t } = useTranslation();
  const links = [
    { href: "/#services", label: t("nav.services"), testid: "nav-services" },
    { href: "/residential", label: t("nav.residential"), testid: "nav-residential" },
    { href: "/commercial", label: t("nav.commercial"), testid: "nav-commercial" },
    { href: "/housing-societies", label: t("nav.housing"), testid: "nav-housing" },
    { href: "/#subsidy", label: t("nav.subsidy"), testid: "nav-subsidy" },
    { href: "/#faq", label: t("nav.faq"), testid: "nav-faq" },
  ];
  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 inset-x-0 z-40 backdrop-blur-md bg-white/90 border-b border-stone-200"
    >
      <nav className="max-w-7xl mx-auto px-5 md:px-10 h-[84px] flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="logo-link">
          <img
            src="/purvodaya-logo.png"
            alt="Purvodaya Solar"
            className="h-16 w-auto object-contain transition-transform group-hover:scale-[1.04]"
            style={{ filter: "drop-shadow(0 1px 2px rgba(15,23,42,0.10))" }}
            data-testid="brand-logo"
          />
          <div className="leading-none hidden sm:block">
            <div
              className="font-display font-black text-[28px] md:text-[30px] tracking-tight text-green-800"
              style={{ letterSpacing: "-0.01em" }}
            >
              Purvodaya<span className="text-orange-500"> Solar</span>
            </div>
          </div>
        </Link>

        <div className="hidden lg:flex items-center gap-6">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm text-stone-700 hover:text-green-700 font-medium transition"
              data-testid={l.testid}
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2 md:gap-3">
          <LanguageSwitcher compact />
          <Link
            to="/admin/login"
            className="hidden sm:inline text-xs text-stone-500 hover:text-stone-800 font-medium"
            data-testid="nav-admin-link"
          >
            {t("nav.admin")}
          </Link>
          <Button
            onClick={onCtaClick}
            data-testid="nav-cta-quote"
            className="rounded-full bg-orange-500 hover:bg-orange-600 text-white px-5 h-10 font-semibold shadow-sm hover:-translate-y-[1px] transition"
          >
            {t("nav.cta")}
          </Button>
          <button
            className="lg:hidden p-2 rounded-lg border border-stone-200"
            onClick={() => setOpen((v) => !v)}
            data-testid="nav-mobile-toggle"
            aria-label={t("nav.menu")}
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </nav>
      {open && (
        <div className="lg:hidden border-t border-stone-200 bg-white">
          <div className="flex flex-col p-4 gap-2">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="py-2 text-stone-700 font-medium"
              >
                {l.label}
              </a>
            ))}
            <Link
              to="/admin/login"
              className="py-2 text-stone-500 text-sm"
              onClick={() => setOpen(false)}
            >
              {t("nav.admin")}
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
